import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0206d58c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_2 = { class: "col bg-grey q-px-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "q-pa-md no-padding" }
const _hoisted_5 = {
  container: "",
  style: {"min-height":"400px"}
}
const _hoisted_6 = {
  elevated: "",
  class: "no-padding no-margin",
  flat: ""
}
const _hoisted_7 = { class: "flex row no-padding" }
const _hoisted_8 = { class: "q-pa-md no-padding" }
const _hoisted_9 = { class: "text-h6" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createVNode(_component_GreenTitle, {
        title: "FAQ",
        class: "q-mb-md"
      }),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_input, {
          borderless: "",
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          debounce: "500",
          color: "primary",
          label: _ctx.$t('Faq.Help'),
          "label-color": "black",
          class: "bg-grey q-mt-lg q-mb-lg"
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "search",
              color: "primary"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "label"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFaqs, (section) => {
        return (_openBlock(), _createElementBlock("div", {
          key: section.id
        }, [
          (section.title != null)
            ? (_openBlock(), _createBlock(_component_q_list, {
                key: 0,
                bordered: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "expand-icon": "add_circle",
                    "expanded-icon": "remove_circle",
                    "expand-icon-class": "text-secondary",
                    color: "blue",
                    group: "somegroup",
                    label: section.title,
                    "header-class": "text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(section.description), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  _createVNode(_component_q_separator)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.search === '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("header", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_q_tabs, {
                      "active-color": "primary",
                      modelValue: _ctx.tabValue,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabValue) = $event)),
                      "indicator-color": "primary",
                      "outside-arrows": "",
                      class: "col"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (category, index) => {
                          return (_openBlock(), _createBlock(_component_q_tab, {
                            key: index,
                            name: 'tabval_'+index,
                            style: {"width":"100%"},
                            class: "text-bold",
                            onClick: ($event: any) => (_ctx.changeCategory(String(index)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(category.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["name", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_q_separator, {
                  style: {"height":"2px"},
                  class: "bg-primary gt-xs"
                }),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (category, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(_component_q_card, {
                          flat: "",
                          class: "my-card",
                          style: {"max-width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (String(index) == _ctx.actualCategory)
                              ? (_openBlock(), _createBlock(_component_q_card, {
                                  key: 0,
                                  flat: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.sections, (section) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: section.id
                                        }, [
                                          (section.title != null)
                                            ? (_openBlock(), _createBlock(_component_q_list, {
                                                key: 0,
                                                bordered: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_expansion_item, {
                                                    "expand-icon": "add_circle",
                                                    "expanded-icon": "remove_circle",
                                                    "expand-icon-class": "text-secondary",
                                                    color: "blue",
                                                    group: "somegroup",
                                                    label: section.title,
                                                    "header-class": "text-primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_q_card, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_q_card_section, { class: "text-subtitle1 markdown-wrapper" }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("div", {
                                                                innerHTML: _ctx.compileMarkDown(section.description ?? '')
                                                              }, null, 8, _hoisted_10)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          (section.links && section.links.length)
                                                            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("ul", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.links, (link) => {
                                                                      return (_openBlock(), _createElementBlock("li", {
                                                                        key: link.id
                                                                      }, [
                                                                        _createElementVNode("a", {
                                                                          target: "_blank",
                                                                          href: _ctx.baseUrl + link.url
                                                                        }, _toDisplayString(link.name), 9, _hoisted_11)
                                                                      ]))
                                                                    }), 128))
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label"]),
                                                  _createVNode(_component_q_separator)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}